import { fromJS } from 'immutable';

export const SET_SELECTED_HOTELS = 'hotels/SET_SELECTED_HOTELS';
export const SET_CONVERSATION_ID = 'hotels/SET_CONVERSATION_ID';

export const setSelectedHotels = (hotels) => ({
  type: SET_SELECTED_HOTELS,
  payload: hotels,
});

export const setConversationId = (id) => ({
  type: SET_CONVERSATION_ID,
  payload: id,
});

const initialState = fromJS({
  selectedHotels: [],
  conversationId: '',
});

// eslint-disable-next-line default-param-last -- ducks
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_HOTELS:
      return state.set('selectedHotels', action.payload);
    case SET_CONVERSATION_ID:
      return state.set('conversationId', action.payload);
    default:
      return state;
  }
}
